import { combineReducers } from 'redux'
import dashboards from './dashboards.reducer'
import dashboardState from './dashboardState.reducer'

export default combineReducers({
  list: dashboards,
  dashboardState
})
